// Components
const LitterReminderComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "litter-reminder-notes"*/'@/app/views/main-view/breeding-management/puppy-management/containers/litter-reminder-notes/litter-reminder-notes.vue');
const LitterNotesComponent = () => import(/* webpackPrefetch: true, webpackChunkName: "litter-note-component"*/'@/app/views/main-view/breeding-management/puppy-management/containers/litter-note-component/litter-note-component.vue');

import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

export default {
    name: 'LitterReminderAndNotesContainer',
    components: {
        LitterReminderComponent,
        LitterNotesComponent
    },
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
            selectedTabComponent: 'LitterNotesComponent',
            tabs: [
                {
                    id: 'notes',
                    label: 'Notes',
                    component: 'LitterNotesComponent',
                    active: true
                },
                {
                    id: 'reminders',
                    label: 'Reminders',
                    component: 'LitterReminderComponent',
                    active: false
                }
            ],

            prevRoute: 'Mating List',
            prevRouteTo: BREEDER_ROUTES.MATING_LIST,
            matingId: null
        }
    },
    computed: {
        getActiveTab() {
            return this.tabs.find(tab => tab.active);
        },
    },
    watch: {},
    created() { 
        if (this.$route.query) {
            if (this.$route.query.from === "litter-list") {
                this.prevRoute = "Puppy List";
                this.prevRouteTo = BREEDER_ROUTES.LITTER_LIST
            } else if (this.$route.query.from === "mating-list") {
                this.prevRoute = "Mating List";
                this.prevRouteTo = BREEDER_ROUTES.MATING_LIST;
            }

            if (this.$route.query.matingId) {
                this.matingId = this.$route.query.matingId
            }

            if (this.$route.query.reminderId) {
                this.reminderId = this.$route.query.reminderId;
                this.setActiveTab('reminders')      
            }
        }
    },
    methods: {
        setActiveTab(selectedTab) {
            this.tabs = this.tabs.map(tab => {
                // set the selected tab to active
                if (tab.id === selectedTab) {
                    tab.active = true;
                    this.selectedTabComponent = tab.component;
                } else {
                    tab.active = false;
                }

                return tab;
            });
        },

        redirectToPrevLocation(matingId) {
            if (!this.prevRouteTo) return;

            if (this.prevRouteTo === BREEDER_ROUTES.LITTER_LIST) {
                this.$router.push(`${BREEDER_ROUTES.LITTER_LIST}?id=${matingId}`);

                return;
            }
            this.$router.push(this.prevRouteTo);
        },
    },
    // third party libraries
}